<ng-container *transloco="let t; read: 'widgets.options'">
  @if (bigNumberOptionsForm.status !== 'DISABLED') {
    <div
      [formGroup]="bigNumberOptionsForm"
      [ngClass]="data.field === 'two' ? 'big-number-chart-options__form-divider' : ''"
    >
      <h2 class="kxi-text-600 kxi-text-large">
        {{ data.displayName }}
      </h2>
      <div class="big-number-chart-options__form_container">
        @if (displayScoringStrategyRadios) {
          <h3 class="kxi-text-medium kxi-text-600 big-number-chart-options__section-wrapper">
            {{ t('metric-calculation-number', { field: data.field }) }}
          </h3>
          @if (analyticItemType !== 'documents') {
            <div class="big-number-chart-options__radio-group">
              @for (group of displayGroups; track group) {
                <div class="big-number-chart-options__radio-button-wrapper">
                  <xi-radio
                    [name]="'scoringStrategyRadios' + data.field"
                    formControlName="scoringStrategyRadios"
                    [value]="group.id"
                    [label]="group.title"
                  ></xi-radio>
                  @if (group.id === 'BOX') {
                    <xi-dropdown
                      [placeholder]="t('sort-fields')"
                      select="single"
                      formControlName="boxDirectionSelect"
                      [data]="boxDirectionDos"
                      [visualState]="'condensed'"
                    ></xi-dropdown>
                    <xi-dropdown
                      [placeholder]="t('sort-fields')"
                      select="single"
                      formControlName="boxSizeSelect"
                      [data]="boxSizeDos"
                      [visualState]="'condensed'"
                    ></xi-dropdown>
                  }
                </div>
              }
            </div>
          }
        }
        @if (displayRatingOptions) {
          <div class="big-number-chart-options__input-group">
            <div class="big-number-chart-options__toggle-group">
              <label for="min-rating" class="kxi-text-small">{{ t('minimum-rating') }}</label>
              <xi-toggle-switch
                id="min-rating"
                [leftText]="0"
                [rightText]="1"
                [isLabelInline]="false"
                [isToggled]="data.scoreRange?.[0] !== '0'"
                (onToggle)="
                  bigNumberOptionsForm.controls.targetRatingToggle.setValue(
                    $event.detail.isToggled ? 1 : 0
                  )
                "
              ></xi-toggle-switch>
            </div>
            <div class="big-number-chart-options__toggle-group">
              <label for="max-target" class="kxi-text-small">{{ t('maximum-rating') }}</label>
              <xi-input-field
                id="max-target"
                required
                formControlName="maxTarget"
                type="number"
                [min]="2"
                [max]="1000"
                visualState="condensed"
                [status]="maxTargetStatus"
              ></xi-input-field>
            </div>
          </div>
        }
        @if (data.isComparisonOrImpact) {
          <h3 class="kxi-text-medium kxi-text-600 big-number-chart-options__section-header">
            {{ t('comparison-options') }}
          </h3>
          <div class="big-number-chart-options__section-wrapper">
            <div class="big-number-chart-options__comparison">
              <label>{{ t('increase') }}:</label>
              @for (radio of comparisonRadios; track radio) {
                <xi-radio
                  [label]="radio.label"
                  [value]="radio.value"
                  [name]="'increaseRadios' + data.field"
                  formControlName="increaseRadios"
                ></xi-radio>
              }
            </div>
            <div class="big-number-chart-options__comparison">
              <label>{{ t('decrease') }}:</label>
              @for (radio of comparisonRadios; track radio) {
                <xi-radio
                  [label]="radio.label"
                  [value]="radio.value"
                  [name]="'decreaseRadios' + data.field"
                  formControlName="decreaseRadios"
                ></xi-radio>
              }
            </div>
          </div>
        }
        <div>
          <label for="precision-dropdown" class="kxi-text-small">{{
            t('decimals-to-display')
          }}</label>
          <div class="big-number-chart-options__small_dropdown">
            <xi-dropdown
              id="precision-dropdown"
              select="single"
              formControlName="intPrecisionSelect"
              [data]="intPrecision"
              [visualState]="'condensed'"
            ></xi-dropdown>
          </div>
        </div>

        <div class="big-number-chart-options__section-wrapper">
          <xi-checkbox
            [label]="t('show-display-name')"
            formControlName="showDisplayName"
          ></xi-checkbox>
        </div>
        @if (data.isComparisonOrImpact) {
          <div class="big-number-chart-options__section-wrapper">
            <xi-toggle-switch
              id="display-as"
              [label]="t('show-as')"
              [leftText]="t('absolute')"
              [rightText]="t('percentage')"
              [isLabelLeft]="true"
              [isToggled]="bigNumberOptionsForm.get('displayDataAs').value !== 'absolute'"
              (onToggle)="
                bigNumberOptionsForm.controls.displayDataAs.setValue(
                  $event.detail.isToggled ? 'percentage' : 'absolute'
                )
              "
            ></xi-toggle-switch>
          </div>
        }
      </div>
    </div>
  } @else {
    @if (bigNumberOptionsForm.status === 'DISABLED') {
      <div
        class="big-number-chart-options__no-options"
        [ngClass]="data.field === 'two' ? 'big-number-chart-options__form-divider' : ''"
      >
        <p class="kxi-text-medium kxi-text-center">
          {{ t('no-chart-options-available', { displayName: data.displayName ?? 'this' }) }}
        </p>
      </div>
    }
  }
</ng-container>
